import useCommonStyles from 'packages/common-utils/common-styles';
import Add from '@material-ui/icons/Add';
import clsx from 'clsx';
import {ChangeEvent, useRef} from 'react';
import useAppSelector from 'packages/hooks/use-app-selector';
import {setFileBlob, selectFileBlob} from 'redux/features/app-slice';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Swal from 'sweetalert2';
import useAppDispatch from 'packages/hooks/use-app-dispatch';

const useStyles = makeStyles((theme) => ({
  defaultButton: {
    outline: 'none',
    cursor: 'pointer',
    background: 'none',
    border: `1px dashed`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      background: theme.palette.grey[100],
    },
    '&:active': {
      background: theme.palette.grey[300],
    },
  },
}));

type Props = {
  disposeModal(): void;
};

const AddSponsor = ({disposeModal}: Props) => {
  const common = useCommonStyles();
  const localAddedBlobs = useAppSelector(selectFileBlob);
  const styles = useStyles();
  const inputRef = useRef(null);
  const dispatch = useAppDispatch();

  const handleAddSponsor = () => {
    if (localAddedBlobs.length >= 2) {
      disposeModal();
      // eslint-disable-next-line no-alert
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No puedes agregar mas de dos patrocinadores por torneo!',
        footer:
          '<a href="https://wa.me/393347749641">¿Quieres cambiar esto? Contacta al adminsitrador de la plataforma</a>',
      });
      return;
    }
    inputRef?.current.click();
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const fileObject = event.target.files[0];
    const blob = URL.createObjectURL(fileObject);
    dispatch(setFileBlob(blob));
  };

  return (
    <>
      <button
        type="button"
        onClick={handleAddSponsor}
        className={clsx([common.sponsor, styles.defaultButton])}
      >
        <input
          ref={inputRef}
          type="file"
          style={{display: 'none'}}
          accept="image/*"
          onChange={handleChange}
        />
        <Add />
      </button>
    </>
  );
};

export default AddSponsor;
